import { Modal, Typography, Descriptions } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/pro-regular-svg-icons'
import { useContext } from 'react'
import { AuthenticationContext } from '../../AuthenticationContext'

type Props = {
  open: boolean
  onClose: () => void
}

const ShareCalendarModal = ({ open, onClose }: Props) => {
  const { currentUser } = useContext(AuthenticationContext)
  const { API_ENDPOINT } = (window as any).env ?? { API_ENDPOINT: '' }
  const webcalPrefix = `${API_ENDPOINT.replace(/^https?/, 'webcal')}/web/calendar-events`

  return (
    <Modal
      title="Subscribe to Calendar"
      open={open}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <Typography.Paragraph type="secondary">
        Sync your schedule with Google Calendar, Outlook, Apple Calendar, and others.
        {' '}<Typography.Link href="https://help.synkedup.com/en/articles/5478693-how-to-export-your-synkedup-consultations-to-another-calendar" target="_blank">Learn how</Typography.Link>
      </Typography.Paragraph>
      <Descriptions bordered column={1}>
        <Descriptions.Item label="My Schedule">
          <Typography.Text copyable={{ icon: <FontAwesomeIcon icon={faCopy} /> }}>{`${webcalPrefix}/webcal/user?token=${currentUser?.token}`}</Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item label="All Users Schedule">
          <Typography.Text copyable={{ icon: <FontAwesomeIcon icon={faCopy} /> }}>{`${webcalPrefix}/webcal/all?token=${currentUser?.token}`}</Typography.Text>
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  )
}

export default ShareCalendarModal
